(() => {
  const dataKey = (type) => `dlx${type.charAt(0).toUpperCase()}${type.slice(1)}`;

  const normalizeList = (value) =>
    String(value || '')
      .split(',')
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean);

  const initFilters = (root) => {
    const grid = root.parentElement?.querySelector('#product-grid') || document.querySelector('#product-grid');
    if (!grid) return;

    const cards = [...grid.querySelectorAll('[data-dlx-filter-card]')];
    if (!cards.length) return;

    const filterTypes = [...new Set([...root.querySelectorAll('[data-dlx-filter]')].map((button) => button.dataset.dlxFilter).filter(Boolean))];
    const state = Object.fromEntries(filterTypes.map((type) => [type, '']));
    const clearButton = root.querySelector('[data-dlx-filter-clear]');
    const status = root.querySelector('[data-dlx-filter-status]');
    const empty = root.querySelector('[data-dlx-filter-empty]');
    const countTextTemplate = root.dataset.dlxFilterCountText || '[[count]] products';
    const selectedText = (count) => (
      count === 1
        ? root.dataset.dlxSelectedOne || `${count} selected`
        : root.dataset.dlxSelectedZero || `${count} selected`
    );

    const apply = () => {
      let visibleCount = 0;

      for (const card of cards) {
        const isVisible = filterTypes.every((type) => {
          if (!state[type]) return true;

          return normalizeList(card.dataset[dataKey(type)]).includes(state[type]);
        });

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      }

      root.querySelectorAll('[data-dlx-filter]').forEach((button) => {
        const type = button.dataset.dlxFilter;
        const value = String(button.dataset.dlxValue || '').trim().toLowerCase();
        const active = state[type] === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-dlx-filter-group]').forEach((group) => {
        const type = group.dataset.dlxFilterGroup;
        const count = state[type] ? 1 : 0;
        const text = selectedText(count);
        const label = group.dataset.dlxFilterLabel || '';
        const summary = group.querySelector('summary');
        group.classList.toggle('is-active', count > 0);

        group.querySelectorAll('[data-dlx-filter-selected]').forEach((selected) => {
          selected.textContent = text;
        });

        group.querySelectorAll('[data-dlx-filter-reset]').forEach((reset) => {
          reset.hidden = count === 0;
        });

        if (summary && label) {
          summary.setAttribute('aria-label', `${label} (${text})`);
        }
      });

      const hasActiveFilter = Object.values(state).some(Boolean);
      if (clearButton) clearButton.hidden = !hasActiveFilter;
      if (status) status.textContent = hasActiveFilter ? countTextTemplate.replace('[[count]]', String(visibleCount)) : '';
      if (empty) empty.hidden = visibleCount > 0;
    };

    root.addEventListener('click', (event) => {
      const filterButton = event.target.closest('[data-dlx-filter]');
      if (filterButton) {
        const type = filterButton.dataset.dlxFilter;
        const value = String(filterButton.dataset.dlxValue || '').trim().toLowerCase();
        state[type] = state[type] === value ? '' : value;
        apply();
        return;
      }

      const resetButton = event.target.closest('[data-dlx-filter-reset]');
      if (resetButton) {
        const type = resetButton.dataset.dlxFilterReset;
        if (type && Object.prototype.hasOwnProperty.call(state, type)) {
          state[type] = '';
          apply();
        }
        return;
      }

      if (event.target.closest('[data-dlx-filter-clear]')) {
        filterTypes.forEach((type) => {
          state[type] = '';
        });
        apply();
      }
    });

    apply();
  };

  const initAll = () => {
    document.querySelectorAll('[data-dlx-collection-filters]').forEach(initFilters);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
